import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_URL } from '@core/config/api-url.token';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';
import { Observable } from 'rxjs';
import { AppointmentRequestListDto } from '../../dtos/appointment-request.dto';

@Injectable()
export class AppointmentRequestsRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  // Status(+kind) filtered list -- backs the recent-cancellations notice
  // (`status=confirmado&kind=cancelacion`), see AppointmentChangeRequestsStore. The backend rejects
  // any status other than `confirmado` with a 400, hence the narrow AppointmentRequestStatus type at
  // the repository boundary. `kind` is omitted from the params object entirely when absent, matching
  // HttpClient's own "no params key => no query string entry" behavior (mirrors `listDepartments`'s
  // optional params).
  public list(status: string, kind?: string): Observable<AppointmentRequestListDto> {
    return this.http.get<AppointmentRequestListDto>(`${this.apiUrl}${API_ENDPOINTS.appointmentRequests.list}`, {
      params: kind ? { status, kind } : { status },
    });
  }
}
